<template>
  <div>
    <div class="page-title">Edit Timeline</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Timeline"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.timeline-lists.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.TimelineList.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.TimelineList.update(this.form);
      this.$router.push("/widgets/timeline-lists");
    },
  },
};
</script>

<style></style>
